module.exports = __webpack_public_path__ + "img/ic_checkbox_checked.92a313cc.svg";